import { render, staticRenderFns } from "./ReferralReactor.vue?vue&type=template&id=e761420c&scoped=true&"
import script from "./ReferralReactor.vue?vue&type=script&lang=ts&"
export * from "./ReferralReactor.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralReactor.vue?vue&type=style&index=0&id=e761420c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e761420c",
  null
  
)

export default component.exports